import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import Store from '../Store/Store'
import Request from '../Request/Request'
import getData from '../Admin/getData'
import Menu from '../Admin/Menu'
import Table from '../AdminCruises/Table'
import { checkToken } from '../AdminCruises/checkToken'

export default function AdminBookings( props ) {

	const navigate = useNavigate()
	const user = Store.get( 'user' )

	const [ tabs, setTabs ] = useState( Store.get( 'categories-list' ) || [] )
	const [ tab, setTab ] = useState( null )
	const tabKey = "id"
	const tabLabel = "title"

	const [ cruiseId, setCruiseId ] = useState( false ) 

	if ( !user ) navigate( '/' )

	useEffect(() => {

		checkToken( e => navigate( '/' ) )

		getData( 'categories-list', setTabs, d => { 
			Store.set( 'categories-list', d ) 
			if ( d && d.length > 0 && tab === null ) {
				setTab( d[ 0 ].id )
			}
		} )

	}, [] )

	useEffect(() => {
		setCruiseId( false ) 
	}, [ tab ] )

	const menuProps = { tabs, tab, setTab, tabKey, tabLabel }
	const commonProps = {}

	return (
		<div style={{ width:'100%', minHheight:'100%', color:'#000' }} >
			<Menu updateContent={ props.updateContent } { ...menuProps }  />

			<Table 
				title="Bookings" table="bookings" api="category-bookings" id={ tab }
				titleStyle={{ margin:'-10px 0 5px 20px' }}
				//select selectedId={ cruiseId } setSelectedId={ setCruiseId }
				showColumns={ [ 'cruise_title', 'name', 'email', 'price', 'paid','cabin_master', 'cabin_vip', 'cabin_standard', 'cabin_bunk' ] }
				allowInsert={ true }
				//insertDefaults={{ 'category_id':tab, 'active':'t' }}
				{ ...commonProps }
			/>

			<div style={{ height:100 }} />

		</div>
	)

}

